import { Image } from "src/swsh-native";
import AnimatedStickerRowItem from "./components/AnimatedStickerRowItem";
import { ParsedStickerRowItem } from "./types";

const StickerRowItem = ({ sticker }: { sticker: ParsedStickerRowItem | null }) => {
	if (!sticker) return null;
	if (sticker.animated) return <AnimatedStickerRowItem sticker={sticker} />;
	return (
		<Image
			alt=""
			src={sticker.url}
			dim={{
				width: sticker.size,
				height: sticker.size,
			}}
			pointerEvents="none"
			contentFit="contain"
			style={{
				position: "absolute",
				top: -sticker.size / 2 - sticker.verticalShift,
				left:
					sticker.side === "left"
						? -sticker.size / 2 - sticker.horizontalShift
						: undefined,
				right:
					sticker.side === "right"
						? -sticker.size / 2 - sticker.horizontalShift
						: undefined,
				width: sticker.size,
				height: sticker.size,
				transform: [{ rotate: `${sticker.rotation}deg` }],
			}}
		/>
	);
};
export default StickerRowItem;
